export default __webpack_public_path__ + "static/07.06-bda9cf49d80c6c85555d2293c8dae84b.png";